<fe-header></fe-header>
<fe-href-subheader [breadcrumbs]="breadcrumbs"></fe-href-subheader>
<main
    class="special-offers"
    [ngStyle]="{
        'background-image': isBackground()
            ? 'url(' + backgroundUrl + ')'
            : 'none',
        'background-color': isBackground() ? 'transparent' : '#005daa',
        'background-size': 'cover',
        'background-position': 'center',
        'background-repeat': 'no-repeat'
    }"
>
    <section class="special-offers__header">
        <div class="special-offers__header__container container">
            <h1 class="special-offers__header__title">
                {{ landingRewardsResponse?.data?.landingRewards?.title }}
            </h1>
            <p class="special-offers__header__info">
                {{ 'fe_special_offers_header_info' | translate }}
            </p>
        </div>
    </section>

    <section class="special-offers__container container">
        <div class="row">
            <div class="special-offers__details col-xs-12 col-sm-5">
                <div class="special-offers__details__image">
                    <img
                        *ngIf="
                            landingRewardsResponse?.data?.landingRewards?.img
                        "
                        class="img-fluid"
                        [src]="
                            landingRewardsResponse?.data?.landingRewards?.img
                        "
                        alt="Promo image"
                    />
                </div>
                <div
                    class="special-offers__details__info"
                    [innerHTML]="
                        landingRewardsResponse?.data?.landingRewards?.content
                    "
                ></div>
            </div>

            <div class="special-offers__form col-xs-12 col-sm-6">
                <form
                    #formInfoOffersElement
                    [formGroup]="formInfoOffers"
                    class="row"
                >
                    <div class="col-xs-12 col-sm-6">
                        <fe-input
                            class="mb-6"
                            [label]="'fe_special_offers_form_name' | translate"
                            [formControlName]="'names'"
                        ></fe-input>
                    </div>
                    <div class="col-xs-12 col-sm-6">
                        <fe-input
                            class="mb-6"
                            [label]="
                                'fe_special_offers_form_last_name' | translate
                            "
                            [formControlName]="'lastName'"
                        ></fe-input>
                    </div>
                    <div class="col-xs-12 col-sm-6">
                        <fe-input
                            class="mb-6"
                            [label]="'fe_special_offers_form_email' | translate"
                            [formControlName]="'email'"
                        ></fe-input>
                    </div>
                    <div class="col-xs-12 col-sm-6">
                        <fe-input
                            class="mb-6"
                            [label]="'fe_special_offers_form_phone' | translate"
                            [formControlName]="'phone'"
                        ></fe-input>
                    </div>
                    <div class="col-xs-12 col-sm-6">
                        <fe-button
                            [loading]="false"
                            class="d-grid"
                            [style]="'primary'"
                            [btnClass]="'border-0'"
                            [loading]="loadingBtnOffers"
                            (onClick)="onClickSendInfoOffers()"
                        >
                            {{ 'fe_special_offers_form_btn' | translate }}
                        </fe-button>
                    </div>
                </form>
                <p class="special-offers__terms col-12 mt-3">
                    {{ 'fe_special_offers_form_tyc' | translate }}
                </p>
                <form
                    #formElement
                    method="post"
                    [action]="this.urlActionInfo"
                    method="post"
                    id="mc-embedded-subscribe-form"
                    name="mc-embedded-subscribe-form"
                >
                    <input
                        type="hidden"
                        [value]="formInfoOffers.get('names')?.value"
                        name="FNAME"
                        id="mce-FNAME"
                    />
                    <input
                        type="hidden"
                        [value]="formInfoOffers.get('lastName')?.value"
                        name="LNAME"
                        id="mce-LNAME"
                    />
                    <input
                        type="hidden"
                        [value]="formInfoOffers.get('email')?.value"
                        name="EMAIL"
                        id="mce-EMAIL"
                    />
                    <input
                        type="hidden"
                        [value]="formInfoOffers.get('phone')?.value"
                        name="PHONE"
                        id="mce-PHONE"
                    />
                </form>
            </div>
        </div>
    </section>
</main>
<fe-footer></fe-footer>
